import React from 'react'
import Home from '../Component/HomePage/Home';
import Contact from '../Component/Contact/Contact';
import Cart from '../Component/AddToCart/Cart';
import { Routes, Route } from "react-router-dom";
import RefundPolicy from '../Component/TermsAndConditions/RefundPolicy';
import PrivcyPolicy from '../Component/TermsAndConditions/PrivacyPolicy';
import TermsOfService from '../Component/TermsAndConditions/TermsOfService';
import ShippingPolicy from '../Component/TermsAndConditions/ShippingPolicy';
import ContactInformation from '../Component/TermsAndConditions/ContactInformation';
import Login from '../Component/Authentication/Login'
import Register from '../Component/Authentication/Register'
import Forgotpassword from '../Component/Authentication/Forgotpassword'
import Topcollections from '../Component/Viewallproducts/Topcollections';
import OurCollection from '../Component/Viewallproducts/OurCollection';
import Electronicscollection from '../Component/Viewallproducts/Electronicscollection';
import Homeimprovement from '../Component/Viewallproducts/Homeimprovement';
import Checkout from '../Component/Checkout/Checkout';
import Productdetail from '../Component/Productdetail/Productdetail';
import { AboutUs } from '../Component/TermsAndConditions/AboutUs';
import Receipt from '../Component/Receipt/Receipt';
import SearchResults from '../Component/SearchResults/SearchResults';
import PasswordChange from '../Component/PasswordChange/PasswordChange';
import Tracker from '../Component/Tracker/Tracker';
// import NavigationMenu from '../Component/NavigationMenu/NavigationMenu';
// import DataProvider from "../Component/ProductCarousal1/DataProvider";
// import Header from '../Component/Header/Header';
// import Footer from '../Component/Footer/Footer';
// import { CartProvider } from '../Component/AddToCart/CartContext';
// import WhatsAppButton from '../Component/WhatsAppButton/WhatsAppButton';
// import { AuthProvider } from '../Component/firebase/AuthContext';
import { CollectionProvider } from '../Component/DashboardProduct/GenericContext';

export default function AppRoutes() {
  return (
    <>
    <CollectionProvider  collectionNames={['featuredProduct', 'trendingProduct']}>
<Routes>
                <Route path='/' Component={Home} />
                <Route path='/contact-us' Component={Contact} />
                <Route path='/cart' Component={Cart} />
                <Route path='/shopnow' Component={Cart} />
                <Route path='/ordernow' Component={Cart} />
                <Route path='/refundpolicy' Component={RefundPolicy} />
                <Route path='/privcypolicy' Component={PrivcyPolicy} />
                <Route path='/termsofservice' Component={TermsOfService} />
                <Route path='/shippingpolicy' Component={ShippingPolicy} />
                <Route path='/contactinformation' Component={ContactInformation} />
                <Route path='/login' element={<Login />} />
                <Route path='/register' element={<Register />} />
                <Route path='/forgotpassword' element={<Forgotpassword />} />
                <Route path='/top_collections' Component={Topcollections} />
                <Route path='/our_collection' Component={OurCollection} />
                <Route path='/electronics' Component={Electronicscollection} />
                <Route path='/home_improvement' Component={Homeimprovement} />
                <Route path='/checkout' Component={Checkout} />
                <Route path="/product_detail/:id" Component={Productdetail} />
                <Route path='/about-us' Component={AboutUs} />
                <Route path='/receipt' element={<Receipt />} />
                <Route path="/search-results" element={<SearchResults  />} />
                <Route path='/password_change' element={<PasswordChange />} />
                <Route path='/tracker' element={<Tracker />} />
                </Routes>
                </CollectionProvider>
    </>
  )
}